import { createContext, useContext } from 'react';
export var RadioGroupContext = /*#__PURE__*/createContext({
  radio: {}
});
export var useRadioGroupContext = function () {
  return useContext(RadioGroupContext);
};